module.exports = __webpack_public_path__ + "static/media/style3-grid-right.df84e6f6.png";